import {gql} from '@apollo/client';

export const GENERATIVE_MODEL_RUNS_QUERY = gql`
  query GenerativeModelRunsQuery($proteinId: StrictString, $moleculeId: StrictString)
  @skipAudit
  @engComponent(name: MODEL_HUB) {
    generativeModelRuns(proteinId: $proteinId, moleculeId: $moleculeId) {
      id
      status
      createdAt
    }
  }
`;

export const GENERATIVE_PREDICTION_JOBS_QUERY = gql`
  query GenerativePredictionJobsQuery($proteinId: StrictString, $moleculeId: StrictString)
  @skipAudit
  @engComponent(name: MODEL_HUB) {
    generativePredictionJobs(proteinId: $proteinId, moleculeId: $moleculeId) {
      id
      statusCode
      createdAt
    }
  }
`;

export const GENERATIVE_MODEL_TOP_PREDICTED_STRUCTURE_FILE_QUERY = gql`
  query GenerativeModelTopPredictedStructureFileQuery($id: StrictString!)
  @skipAudit
  @engComponent(name: MODEL_HUB) {
    generativeModelRun(id: $id) {
      id
      topPredictedStructureFile {
        signedUrl
      }
    }
  }
`;

export const GENERATIVE_MODEL_ZIPPED_FULL_RESULTS_FILE_QUERY = gql`
  query GenerativeModelZippedFullResultsFileQuery($id: StrictString!)
  @skipAudit
  @engComponent(name: MODEL_HUB) {
    generativeModelRun(id: $id) {
      id
      zippedFullResultsFile {
        signedUrl
      }
    }
  }
`;
